import Pdf from "../assets/images/icons/pdf.png";
import Doc from "../assets/images/icons/doc.png";
import Txt from "../assets/images/icons/txt.png";
import Xls from "../assets/images/icons/xls.png";
import Ppt from "../assets/images/icons/ppt.png";

export const DOCUMENTS_EXE_ICONS = new Map<string, string>([
  ["pdf", Pdf],
  ["doc", Doc],
  ["docx", Doc],
  ["txt", Txt],
  ["xls", Xls],
  ["xlsx", Xls],
  ["ppt", Ppt],
  ["pptx", Ppt],
]);
